// NOTE: ONLY CHANGE VALUES INSIDE INGREDIENTS ARRAY. PLEASE FOLLOW THE LAYOUT AS IN EXAMPLE BELOW
// DON'T FORGET TO ADD commas after each object
// After unit there's no comma 

const INGREDIENTS = [
  {
name: "All Purpose Flour",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/All_Purpose_Flour.png?v=1672888313",
code: "BS001",
price: 0.00297,
unit: "g",
category: "flour"
},
{
name: "Bread Flour",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Bread_Flour.png?v=1672888313",
code: "BS002",
price: 0.00396,
unit: "g",
  category: "flour"
},
{
name: "Cake Flour",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Cake_Flour.png?v=1672888313",
code: "BS003",
price: 0.00414,
unit: "g",
category: "flour"
},
{
name: "Corn Flour",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Corn_Starch.png?v=1672888313",
code: "BS004",
price: 0.00396,
unit: "g",
category: "flour"
},
{
name: "Glutinuous Rice Flour",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Glutinuous_Rice_Flour.png?v=1672888313",
code: "BS005",
price: 0.00570,
unit: "g"  
},
{
name: "Baking Powder",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Baking_Powder.png?v=1672888313",
code: "BS009",
price: 0.00864,
unit: "g",
category: "flour"
},
{
name: "Baking Soda",
image: "https://cdn.shopify.com/s/files/1/1128/0456/files/Baking_Soda.png?v=1672888313",
code: "BS010",
price: 0.00510,
unit: "g"
},
{
name: "Brown Sugar",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Brown_Sugar_40773fcb-a599-413b-9722-127bd6bd3fbb.png?v=1672888313",
code: "BS020",
price: 0.00594,
unit: "g"
},
{
name: "Granulated Sugar",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Granulated_White_Sugar.png?v=1672888313",
code: "BS021",
price: 0.00252,
unit: "g"
},
{
name: "Confectioners' Sugar",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/frozen-treat-sprinkles.jpg?v=1668962172",
code: "BS023",
price: 0.00432,
unit: "g"
},
{
name: "Cocoa Powder",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Cocoa_Powder.png?v=1672888313",
code: "BS040",
price: 0.0144,
unit: "g"
},
{
name: "Milk Powder",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Milk_Powder.png?v=1672888313",
code: "BS041",
price: 0.01553,
unit: "g"
},
{
name: "Cinnamon Powder",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Cinnamon_Powder.png?v=1672888313",
code: "BS042",
price: 0.03093,
unit: "g"
},
{
name: "Matcha Powder",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Matcha_Powder.png?v=1672888313",
code: "BS043",
price: 0.25567,
unit: "g"
},
{
name: "Gelatin Powder",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/frozen-treat-sprinkles.jpg?v=1668962172",
code: "BS045",
price: 0.036,
unit: "g"
},
{
name: "Instant Yeast",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/frozen-treat-sprinkles.jpg?v=1668962172",
code: "BS046",
price: 0.04909,
unit: "g"
},
{
name: "Coconut Cream Powder",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/frozen-treat-sprinkles.jpg?v=1668962172",
code: "BS047",
price: 0.024,
unit: "g"
},
{
name: "Coffee Powder",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/frozen-treat-sprinkles.jpg?v=1668962172",
code: "BS048",
price: 0.05625,
unit: "g"
},
{
name: "Nutmeg",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Nutmeg.png?v=1672888313",
code: "BS049",
price: 0.06542,
unit: "g"
},
{
name: "Lavender Flowers",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/frozen-treat-sprinkles.jpg?v=1668962172",
code: "BS049",
price: 0.29952,
unit: "g"
},
{
name: "Almond Meal",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Almond_Meal_Fine.png?v=1672888313",
code: "BS080",
price: 0.01875,
unit: "g"
},
{
name: "Desiccated Coconut",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Desiccated_Coconut.png?v=1672888313",
code: "BS081",
price: 0.0144,
unit: "g"
},
{
name: "Dried Cranberries",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Dried_Cranberries.png?v=1672888313",
code: "BS082",
price: 0.0117,
unit: "g"
},
{
name: "Almonds (Sliced)",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Sliced_Almonds.png?v=1672888313",
code: "BS083",
price: 0.01875,
unit: "g"
},
{
name: "Hazelnuts",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Hazelnuts.png?v=1672888313",
code: "BS084",
price: 0.02625,
unit: "g"
},
{
name: "Walnuts",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Walnuts.png?v=1672888313",
code: "BS085",
price: 0.0195,
unit: "g"
},
{
name: "Pistachios",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Pistachios.png?v=1672888313",
code: "BS086",
price: 0.0258,
unit: "g"
},
{
name: "Dark Chocolate Buttons, Couverture, Callbeaut",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Dark_Chocolate_Couverture.png?v=1672888313",
code: "BS100",
price: 0.0219,
unit: "g"
},
{
name: "Mini Chocolate Chips",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Mini_Chocolate_Chips.png?v=1672888313",
code: "BS101",
price: 0.01521,
unit: "g"
},
{
name: "White Chocolate Couverture",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/White_Chocolate_Couverture.png?v=1672888313",
code: "BS102",
price: 0.0195,
unit: "g"
},
{
name: "White Chocolate Compound Buttons",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/White_Cocoa_Compound_Buttons.png?v=1672888313",
code: "BS103",
price: 0.01224,
unit: "g"
},
{
name: "White Chocolate Chips",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/White_Chocolate_Chips.png?v=1672888313",
code: "BS104",
price: 0.0153,
unit: "g"
},
{
name: "Medium Marshmallows",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/Medium_Marshmallows.png?v=1672910474",
code: "BS130",
price: 0.012,
unit: "g"
},
{
name: "Digestive Biscuits",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/frozen-treat-sprinkles.jpg?v=1668962172",
code: "BS131",
price: 0.0099,
unit: "g"
},
{
name: "Vanilla",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/frozen-treat-sprinkles.jpg?v=1668962172",
code: "BS134",
price: 0.03008,
unit: "g"
},
{
name: "Pandan Paste",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/frozen-treat-sprinkles.jpg?v=1668962172",
code: "BS135",
price: 0.03593,
unit: "g"
},
{
name: "Strawberry Red Food Colouring",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/frozen-treat-sprinkles.jpg?v=1668962172",
code: "BS136",
price: 0.00756,
unit: "g"
},
{
name: "Green Food Coloring",
image: "//cdn.shopify.com/s/files/1/1128/0456/files/frozen-treat-sprinkles.jpg?v=1668962172",
code: "BS137",
price: 0.00756,
unit: "g"
}
]






